export default __webpack_public_path__ + "static/media/cat-ham.23c3f957.jpg";